import { BulkManagementTablePrimitivesRoot } from './BulkManagementTablePrimitivesRoot';
import { BulkManagementTablePrimitivesGrid } from './BulkManagementTablePrimitivesGrid';

export const BulkManagementTablePrimitives = {
  Root: BulkManagementTablePrimitivesRoot,
  Grid: BulkManagementTablePrimitivesGrid,
};
